import { Modal, SelectInput } from "@risalabs_frontend_org/oasis-ui-kit";
import { HistoricNarClearReason } from "../../../../../../shared/api/services/historicNar/types";
import { ModalId } from "../../../../../../shared/enums/modalId";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";
import useNeedsReview from "../hooks/useNeedsReview";

export const NEEDS_REVIEW_REASON_OPTIONS = Object.values(
  HistoricNarClearReason,
).map((reason) => ({
  label: capitalizeWordsSeperatedByUnderScore(reason),
  value: reason,
}));

interface NeedsReviewModalProps {
  identifier?: string;
  onClose: () => void;
  onReIngest: () => void;
}

/** Clear a Needs Review lane before closing or continuing to re-ingestion. */
const NeedsReviewModal = ({
  identifier,
  onClose,
  onReIngest,
}: NeedsReviewModalProps) => {
  const review = useNeedsReview({ identifier, onClose, onReIngest });
  return (
    <Modal
      dialogId={ModalId.NEEDS_REVIEW_MODAL}
      onSave={review.handleReIngest}
      onCancel={review.handleSave}
      title="Needs Review"
      saveButtonText={review.saveButtonText}
      cancelText={review.cancelText}
      onClose={onClose}
      disableSave={review.disableActions}
      disableCancel={review.disableActions}
      disableOnCloseFunc
      disableCloseOnOutsideClick={review.isSubmitting}
      maxHeightPercentage={50}
    >
      <SelectInput
        options={NEEDS_REVIEW_REASON_OPTIONS}
        label="Review Reason"
        placeholder="Select a reason"
        onChange={review.handleReasonChange}
      />
    </Modal>
  );
};

export default NeedsReviewModal;
